import React from 'react';
import axios from 'axios';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as CircleInfo } from '../../icons/circle-info.svg';

const SendFeedbackPanel = ({ closeModal }) => {
  const [email, setEmail] = React.useState('');
  const [type, setType] = React.useState('Работа с системой');
  const [feedback, setFeedback] = React.useState('');

  const [status, setStatus] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) return setLoading(false);
    
    axios.get('/api/get-account-info', {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }).then(response => {
        setEmail(response.data.email);
    }).finally(() => {
        setLoading(false);
    });
  }, []);

  const [isShowSuccessScreen, setIsShowSuccessScreen] = React.useState(false);

  const sendFeedback = (e) => {
    e.preventDefault();

    setLoading(true);

    axios.post(`/api/send-feedback?email=${email}&type=${type}&message=${feedback}`)
    .then(() => {
      setStatus('Обращение отправлено');
      setIsShowSuccessScreen(true);
    })
    .catch((error) => {
      setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
    })
    .finally(() => {
      setLoading(false);
    })
  }


  return (
    <>
      <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
        {!isShowSuccessScreen ?
        <>
        <div className={styles.header}>
          <h1>Оставьте отзыв или опишите проблему</h1>
          {closeModal && <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />}
        </div>
        <div className={styles.main}>
          <div className='labelInputWrapper'>
            <a className='label'>Адрес электронной почты для связи</a>
            <div className='labelInputRight'>
              <div className='inputWrapper'>
                <input 
                  type='text' 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  placeholder='' 
                  minLength='' 
                  maxLength='' 
                  disabled={loading}
                  required />
              </div>
            </div>
          </div>
          <div className='labelInputWrapper'>
            <a className='label'>О чем обращение</a>
            <div className='labelInputRight'>
                <div className='radioSwitchWrapper'>
                    <label className={`radioSwitchLabel ${type === 'Работа с системой' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='Работа с системой'
                            checked={type === 'Работа с системой'}
                            onChange={(e) => setType(e.target.value)}
                        />
                        <span>О работе системы</span>
                    </label>
                    <label className={`radioSwitchLabel ${type === 'Работа с СРО' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='Работа с СРО'
                            checked={type === 'Работа с СРО'}
                            onChange={(e) => setType(e.target.value)}
                        />
                        <span>О работе с СРО</span>
                    </label>
                </div>
            </div>
          </div>
          <div className='labelInputWrapper'>
            <a className='label'>Опишите проблему</a>
            <div className='labelInputRight'>
              <div className='inputWrapper'>
                <textarea 
                    cols='10' 
                    rows='10' 
                    value={feedback}  
                    onChange={(e) => setFeedback(e.target.value)}
                    minLength='' 
                    maxLength='1000' 
                    disabled={loading}
                    require=''
                >
                </textarea>
                <p className='description'>{feedback.length}/1000</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <div>{status}</div>
          {loading ? <Loading type={'inline'} /> :
          <button 
            className='button black' 
            onClick={sendFeedback}
            disabled={loading}
          >
            Отправить
          </button>}
        </div>
        </>
        :
        <>
          <div className={styles.header}>
            <h1>Спасибо за обращение</h1>
            {closeModal && <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />}
          </div>
          <div className={styles.main}>
            <IconContainer Icon={CircleInfo} isClickable={false} onClick={() => {}} size = '30' color = '#0a9f3c' className = '' />
            <h1>Ваше обращение успешно отправлено</h1>
            <p style={{fontSize: '14px'}}>В ближайшее время с Вами свяжется технический специалист или работник аппарата СРО по указанной ранее почте.</p>
            <p style={{fontSize: '14px'}}>Это окно можно закрыть.</p>
          </div>
          <div style={{height: '40px'}}></div>
        </>}
      </div>
    </>
  );
};

export default SendFeedbackPanel;
